module.exports = __webpack_public_path__ + "static/media/icon-padlock.310723d9.svg";